import Grid2 from "../../src/assets/projects/method/1.webp";
import Grid3 from "../../src/assets/projects/method/2.webp";
import Grid4 from "../../src/assets/homepage/grid/grid4.webp";
import Grid5 from "../../src/assets/homepage/grid/grid5.webp";
import Man1 from "../../src/assets/projects/man/1.webp";
import Man2 from "../../src/assets/projects/man/2.webp";
import Man3 from "../../src/assets/projects/man/3.webp";
import Man4 from "../../src/assets/projects/man/4.webp";
import Man5 from "../../src/assets/projects/man/5.webp";
import Man6 from "../../src/assets/projects/man/6.webp";
import Man7 from "../../src/assets/projects/man/7.webp";
import Method1 from "../../src/assets/projects/method/1.webp";
import Method2 from "../../src/assets/projects/method/2.webp";
import Method3 from "../../src/assets/projects/method/3.webp";
import Method4 from "../../src/assets/projects/method/4.webp";
import Method5 from "../../src/assets/projects/method/5.webp";
import Method6 from "../../src/assets/projects/method/6.webp";

import Youngbirds1 from "../assets/projects/competitons/youngbirds/1.webp";
import Youngbirds2 from "../assets/projects/competitons/youngbirds/2.webp";
import Youngbirds3 from "../assets/projects/competitons/youngbirds/3.webp";
import Youngbirds4 from "../assets/projects/competitons/youngbirds/4.webp";
import Youngbirds5 from "../assets/projects/competitons/youngbirds/5.webp";
import Youngbirds6 from "../assets/projects/competitons/youngbirds/6.webp";
import Youngbirds7 from "../assets/projects/competitons/youngbirds/7.webp";
import Youngbirds8 from "../assets/projects/competitons/youngbirds/8.webp";
import Youngbirds9 from "../assets/projects/competitons/youngbirds/9.webp";

import TajLogo from "../assets/projects/competitons/tajbiennale/1.webp";
import BlackTaj1 from "../assets/projects/competitons/tajbiennale/2.webp";
import BlackTaj2 from "../assets/projects/competitons/tajbiennale/3.webp";
import BlackTaj3 from "../assets/projects/competitons/tajbiennale/4new.webp";
import BlackTaj4 from "../assets/projects/competitons/tajbiennale/5 (2).webp";
import BlackTaj5 from "../assets/projects/competitons/tajbiennale/6.webp";

import Coe1 from "../assets/projects/competitons/centerofexe/1.webp";
import Coe2 from "../assets/projects/competitons/centerofexe/2.webp";
import Coe3 from "../assets/projects/competitons/centerofexe/3.webp";
import Coe4 from "../assets/projects/competitons/centerofexe/4.webp";
import Coe5 from "../assets/projects/competitons/centerofexe/5 (1).webp";
import Coe6 from "../assets/projects/competitons/centerofexe/6.webp";
import Coe7 from "../assets/projects/competitons/centerofexe/7.webp";
import Coe8 from "../assets/projects/competitons/centerofexe/8.webp";
import Coe9 from "../assets/projects/competitons/centerofexe/9.webp";

import URU1 from "../assets/projects/uru_brew/URU-01.jpg";
import URU2 from "../assets/projects/uru_brew/URU-02.jpg";
import URU3 from "../assets/projects/uru_brew/URU-03.jpg";
import URU4 from "../assets/projects/uru_brew/URU-04.jpg";
import URU5 from "../assets/projects/uru_brew/URU-05.jpg";
import URU6 from "../assets/projects/uru_brew/URU-06.jpg";
import URU7 from "../assets/projects/uru_brew/URU-07.jpg";
import URU8 from "../assets/projects/uru_brew/URU-08.jpg";
import URU9 from "../assets/projects/uru_brew/URU-09.jpg";
import URU10 from "../assets/projects/uru_brew/URU-10.jpg";
import URU11 from "../assets/projects/uru_brew/URU-11.jpg";
import URU12 from "../assets/projects/uru_brew/URU-12.jpg";

import SOCIALBELLA1 from "../assets/projects/social_bella/SOCIAL BELLA-01.jpg";
import SOCIALBELLA2 from "../assets/projects/social_bella/SOCIAL BELLA-02.jpg";
import SOCIALBELLA3 from "../assets/projects/social_bella/SOCIAL BELLA-03.jpg";
import SOCIALBELLA4 from "../assets/projects/social_bella/SOCIAL BELLA-04.jpg";
import SOCIALBELLA5 from "../assets/projects/social_bella/SOCIAL BELLA-05.jpg";
import SOCIALBELLA6 from "../assets/projects/social_bella/SOCIAL BELLA-06.jpg";
import SOCIALBELLA7 from "../assets/projects/social_bella/SOCIAL BELLA-07.jpg";
import SOCIALBELLA8 from "../assets/projects/social_bella/SOCIAL BELLA-08.jpg";
import SOCIALBELLA9 from "../assets/projects/social_bella/SOCIAL BELLA-09.jpg";
import SOCIALBELLA10 from "../assets/projects/social_bella/SOCIAL BELLA-10.jpg";
import SOCIALBELLA11 from "../assets/projects/social_bella/SOCIAL BELLA-11.jpg";
import SOCIALBELLA12 from "../assets/projects/social_bella/SOCIAL BELLA-12.jpg";
import SOCIALBELLA13 from "../assets/projects/social_bella/SOCIAL BELLA-13.jpg";
import SOCIALBELLA14 from "../assets/projects/social_bella/SOCIAL BELLA-14.jpg";
import SOCIALBELLA15 from "../assets/projects/social_bella/SOCIAL BELLA-15.jpg";
import SOCIALBELLA16 from "../assets/projects/social_bella/SOCIAL BELLA-16.jpg";

import RECORDROOM1 from "../assets/projects/recordroom/RECORD -01.jpg";
import RECORDROOM2 from "../assets/projects/recordroom/RECORD -02.jpg";
import RECORDROOM3 from "../assets/projects/recordroom/RECORD -03.jpg";
import RECORDROOM4 from "../assets/projects/recordroom/RECORD -04.jpg";
import RECORDROOM5 from "../assets/projects/recordroom/RECORD -05.jpg";
import RECORDROOM6 from "../assets/projects/recordroom/RECORD -06.jpg";
import RECORDROOM7 from "../assets/projects/recordroom/RECORD -07.jpg";
import RECORDROOM8 from "../assets/projects/recordroom/RECORD -08.jpg";
import RECORDROOM9 from "../assets/projects/recordroom/RECORD -09.jpg";
import RECORDROOM10 from "../assets/projects/recordroom/RECORD -10.jpg";

import LACASA1 from "../assets/projects/lacasa/LA CASA-01.jpg";
import LACASA2 from "../assets/projects/lacasa/LA CASA-02.jpg";
import LACASA3 from "../assets/projects/lacasa/LA CASA-03.jpg";
import LACASA4 from "../assets/projects/lacasa/LA CASA-04.jpg";
import LACASA5 from "../assets/projects/lacasa/LA CASA-05.jpg";
import LACASA6 from "../assets/projects/lacasa/LA CASA-06.jpg";
import LACASA7 from "../assets/projects/lacasa/LA CASA-07.jpg";
import LACASA8 from "../assets/projects/lacasa/LA CASA-08.jpeg";
import LACASA9 from "../assets/projects/lacasa/LA CASA-09.jpeg";
import LACASA10 from "../assets/projects/lacasa/LA CASA-10.jpg";
import LACASA11 from "../assets/projects/lacasa/LA CASA-11.jpg";


import ROUND1 from "../assets/projects/round/ROUND-01.jpg";
import ROUND2 from "../assets/projects/round/ROUND-02.jpg";
import ROUND3 from "../assets/projects/round/ROUND-03.jpg";
import ROUND4 from "../assets/projects/round/ROUND-04.jpg";
import ROUND5 from "../assets/projects/round/ROUND-05.jpg";
import ROUND6 from "../assets/projects/round/ROUND-06.jpg";
import ROUND7 from "../assets/projects/round/ROUND-07.jpg";
import ROUND8 from "../assets/projects/round/ROUND-08.jpg";
import ROUND9 from "../assets/projects/round/ROUND-09.jpg";
import ROUND10 from "../assets/projects/round/ROUND-10.jpg";


import KAAVU1 from "../assets/projects/kaavu/KAAVU-01.jpg";
import KAAVU2 from "../assets/projects/kaavu/KAAVU-02.jpg";
import KAAVU3 from "../assets/projects/kaavu/KAAVU-03.jpg";
import KAAVU4 from "../assets/projects/kaavu/KAAVU-04.jpg";
import KAAVU5 from "../assets/projects/kaavu/KAAVU-05.jpg";
import KAAVU6 from "../assets/projects/kaavu/KAAVU-06.jpg";
import KAAVU7 from "../assets/projects/kaavu/KAAVU-07.jpg";
import KAAVU8 from "../assets/projects/kaavu/KAAVU-08.jpg";
import KAAVU9 from "../assets/projects/kaavu/KAAVU-09.jpg";
import KAAVU10 from "../assets/projects/kaavu/KAAVU-10.jpg";
import KAAVU11 from "../assets/projects/kaavu/KAAVU-11.jpg";
import KAAVU12 from "../assets/projects/kaavu/KAAVU-12.jpg";
import KAAVU13 from "../assets/projects/kaavu/KAAVU-13.jpg";
import KAAVU14 from "../assets/projects/kaavu/KAAVU-14.jpg";
import KAAVU15 from "../assets/projects/kaavu/KAAVU-15.jpg";

import GCBC1 from "../assets/projects/gcbc/GCBC-01.jpg";
import GCBC2 from "../assets/projects/gcbc/GCBC-02.jpg";
import GCBC3 from "../assets/projects/gcbc/GCBC-03.jpg";
import GCBC4 from "../assets/projects/gcbc/GCBC-04.jpg";
import GCBC5 from "../assets/projects/gcbc/GCBC-05.jpg";
import GCBC6 from "../assets/projects/gcbc/GCBC-06.jpg";
import GCBC7 from "../assets/projects/gcbc/GCBC-07.jpg";
import GCBC8 from "../assets/projects/gcbc/GCBC-08.jpg";
import GCBC9 from "../assets/projects/gcbc/GCBC-09.jpg";
import GCBC10 from "../assets/projects/gcbc/GCBC-10.jpg";
import GCBC11 from "../assets/projects/gcbc/GCBC-11.jpg";

import ESONG1 from "../assets/projects/earth-song/EARTH SONG-01.jpg";
import ESONG2 from "../assets/projects/earth-song/EARTH SONG-02.jpeg";
import ESONG3 from "../assets/projects/earth-song/EARTH SONG-03.jpeg";
import ESONG4 from "../assets/projects/earth-song/EARTH SONG-04.jpg";
import ESONG5 from "../assets/projects/earth-song/EARTH SONG-05.jpg";
import ESONG6 from "../assets/projects/earth-song/EARTH SONG-06.jpg";
import ESONG7 from "../assets/projects/earth-song/EARTH SONG-07.jpg";
import ESONG8 from "../assets/projects/earth-song/EARTH SONG-08.jpg";
import ESONG9 from "../assets/projects/earth-song/EARTH SONG-09.jpg";
import ESONG10 from "../assets/projects/earth-song/EARTH SONG-10.jpg";
import ESONG11 from "../assets/projects/earth-song/EARTH SONG-11.jpg";
import ESONG12 from "../assets/projects/earth-song/EARTH SONG-12.jpg";
import ESONG13 from "../assets/projects/earth-song/EARTH SONG-13.jpg";
import ESONG14 from "../assets/projects/earth-song/EARTH SONG-14.jpeg";
import ESONG15 from "../assets/projects/earth-song/EARTH SONG-15.jpg";
import ESONG16 from "../assets/projects/earth-song/EARTH SONG-16.jpg";
import ESONG17 from "../assets/projects/earth-song/EARTH SONG-17.jpg";
import ESONG18 from "../assets/projects/earth-song/EARTH SONG-18.jpeg";
import ESONG19 from "../assets/projects/earth-song/EARTH SONG-19.jpg";
import ESONG20 from "../assets/projects/earth-song/EARTH SONG-20.jpg";
import ESONG21 from "../assets/projects/earth-song/EARTH SONG-21.jpg";

import MANCHANDA1 from "../assets/projects/manchanda/MANCHANDA-01.jpg";
import MANCHANDA2 from "../assets/projects/manchanda/MANCHANDA-02.jpg";
import MANCHANDA3 from "../assets/projects/manchanda/MANCHANDA-03.jpg";
import MANCHANDA4 from "../assets/projects/manchanda/MANCHANDA-04.jpg";
import MANCHANDA5 from "../assets/projects/manchanda/MANCHANDA-05.jpg";
import MANCHANDA6 from "../assets/projects/manchanda/MANCHANDA-06.jpg";
import MANCHANDA7 from "../assets/projects/manchanda/MANCHANDA-07.jpg";
import MANCHANDA8 from "../assets/projects/manchanda/MANCHANDA-08.jpg";
import MANCHANDA9 from "../assets/projects/manchanda/MANCHANDA-09.jpg";
import MANCHANDA10 from "../assets/projects/manchanda/MANCHANDA-10.jpg";
import MANCHANDA11 from "../assets/projects/manchanda/MANCHANDA-11.jpg";
import MANCHANDA12 from "../assets/projects/manchanda/MANCHANDA-12.jpg";
import MANCHANDA13 from "../assets/projects/manchanda/MANCHANDA-13.jpg";
import MANCHANDA14 from "../assets/projects/manchanda/MANCHANDA-14.jpg";
import MANCHANDA15 from "../assets/projects/manchanda/MANCHANDA-15.jpg";

import P5151 from "../assets/projects/515/515-01.jpg";
import P5152 from "../assets/projects/515/515-02.jpg";
import P5153 from "../assets/projects/515/515-03.jpg";
import P5154 from "../assets/projects/515/515-04.jpg";
import P5155 from "../assets/projects/515/515-05.jpg";
import P5156 from "../assets/projects/515/515-06.jpg";
import P5157 from "../assets/projects/515/515-07.jpg";
import P5158 from "../assets/projects/515/515-08.jpg";
import P5159 from "../assets/projects/515/515-09.jpg";
import P51510 from "../assets/projects/515/515-10.jpg";

import MARATT1 from "../assets/projects/maratt/MARATT-01.jpg";
import MARATT2 from "../assets/projects/maratt/MARATT-02.jpg";
import MARATT3 from "../assets/projects/maratt/MARATT-03.jpg";
import MARATT4 from "../assets/projects/maratt/MARATT-04.jpg";
import MARATT5 from "../assets/projects/maratt/MARATT-05.jpg";
import MARATT6 from "../assets/projects/maratt/MARATT-06.jpg";
import MARATT7 from "../assets/projects/maratt/MARATT-07.jpg";
import MARATT8 from "../assets/projects/maratt/MARATT-08.jpg";
import MARATT9 from "../assets/projects/maratt/MARATT-09.jpg";
import MARATT10 from "../assets/projects/maratt/MARATT-10.jpg";
import MARATT11 from "../assets/projects/maratt/MARATT-11.jpg";
import MARATT12 from "../assets/projects/maratt/MARATT-12.jpg";
import MARATT13 from "../assets/projects/maratt/MARATT-13.jpg";
import MARATT14 from "../assets/projects/maratt/MARATT-14.jpg";

import TRANSIT1 from "../assets/projects/transit/TRANSIT-01.jpg";
import TRANSIT2 from "../assets/projects/transit/TRANSIT-02.jpg";
import TRANSIT3 from "../assets/projects/transit/TRANSIT-03.jpg";
import TRANSIT4 from "../assets/projects/transit/TRANSIT-04.jpg";
import TRANSIT5 from "../assets/projects/transit/TRANSIT-05.jpg";
import TRANSIT6 from "../assets/projects/transit/TRANSIT-06.jpg";
import TRANSIT7 from "../assets/projects/transit/TRANSIT-07.jpg";
import TRANSIT8 from "../assets/projects/transit/TRANSIT-08.jpg";
import TRANSIT9 from "../assets/projects/transit/TRANSIT-09.jpg";
import TRANSIT10 from "../assets/projects/transit/TRANSIT-10.jpg";
import TRANSIT11 from "../assets/projects/transit/TRANSIT-11.jpg";
import TRANSIT12 from "../assets/projects/transit/TRANSIT-12.jpg";

import MICELIO1 from "../assets/projects/micelio/micelio-01.jpg";
import MICELIO2 from "../assets/projects/micelio/micelio-02.jpg";
import MICELIO3 from "../assets/projects/micelio/micelio-03.jpg";
import MICELIO4 from "../assets/projects/micelio/micelio-04.jpg";
import MICELIO5 from "../assets/projects/micelio/micelio-05.jpg";
import MICELIO6 from "../assets/projects/micelio/micelio-06.jpg";
import MICELIO7 from "../assets/projects/micelio/micelio-07.jpg";
import MICELIO11 from "../assets/projects/micelio/micelio-11.jpg";
import MICELIO12 from "../assets/projects/micelio/micelio-12.jpg";
import MICELIO13 from "../assets/projects/micelio/micelio-13.jpg";
import MICELIO14 from "../assets/projects/micelio/micelio-14.jpg";
import MICELIO15 from "../assets/projects/micelio/micelio-15.jpg";
import MICELIO16 from "../assets/projects/micelio/micelio-16.jpg";

const projectPageData = [
  {
    projectName: "man",
    style: "grid-image",
    pageUrl: "man",
    projectDetails: [
      {
        imageSrc: Man1,
      },
      {
        imageSrc: Man2,
      },
      {
        imageSrc: Man3,
      },
      {
        imageSrc: Man4,
      },
      {
        imageSrc: Man5,
      },
      {
        imageSrc: Man6,
      },
      {
        imageSrc: Man7,
      },
    ],
  },
  {
    projectName: "method",
    pageUrl: "method",
    style: "image-padding",
    projectDetails: [
      {
        imageSrc: Method1,
        class: "",
        title: "MATERIAL MANIFESTO",
        subTitle:
          "The skeleton, body and skin of a building are made with materials. We choose and modify them with the greatest care and attention to detail, in resonance with our tradition, climate and crafts.",
      },
      {
        imageSrc: Method2,
        class: "",
        title: "CONTEXT IS EVERYTHING",
        subTitle:
        "The client, the business plan, the users, the neighbors, the place, the ecology, the process – everything is context. An honest reading of this contextual landscape helps liberate true value.",
      },
      {
        imageSrc: Method3,
        class: "",
        title: "TREE HUGGERS",
        subTitle:
          "Architecture is an extension of the earth we inhabit. For a sustainable future, design must respect and evolve from this ecology.",
      },
      {
        imageSrc: Method4,
        class: "",
        title: "THE EFFORTLESS ENOUGH",
        subTitle:
          "In this time of excess it is crucial to exercise restrain. We feel that beauty and utility can be achieved through frugal means.",
      },
      {
        imageSrc: Method5,
        class: "",
        title: "BUILDING STORIES STOREY BUILDING",
        subTitle:
          "Good architecture, like a good story is about finding the appropriate narrative. For us, this inspiration comes from being good listeners and observers.",
      },
      {
        imageSrc: Method6,
        class: "",
        title: "PURVEYORS OF THE ZEITGEIST",
        subTitle:
          "Today the past, present and future culturally coexist as a singularity. We seek to create from this rich continuum, a fresh spirit of our times.",
      },
    ],
  },
  {
    project: "hospitality",
    projectName: "uru",
    style: "grid-image",
    projectDetails: [
      {
        imageSrc: Grid2,
        class: "grid2",
        verticalText: "1/13",
        title: "uru,bangalore",
      },
      {
        description:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic",
      },
      {
        imageSrc: Grid3,
        class: "",
        verticalText: "2/13",
      },
      {
        imageSrc: Grid4,
        class: "",
        verticalText: "3/13 ",
      },
      {
        imageSrc: Grid5,
        class: "",
        verticalText: "4/13",
      },
    ],
  },
  {
    project: "competitions",
    projectName: "taj-biennale",
    style: "grid-image",
    titleLogoSrc: TajLogo,
    projectDetails: [
      {
        imageSrc: Grid2,
        class: "grid2",
        verticalText: "1/13",
      },
      {
        description:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic",
      },
      {
        imageSrc: Grid3,
        class: "",
        verticalText: "2/13",
      },
      {
        imageSrc: Grid4,
        class: "",
        verticalText: "3/13 ",
      },
      {
        imageSrc: Grid5,
        class: "",
        verticalText: "4/13",
      },
    ],
  },
  {
    project: "competitions",
    projectName: "black-taj",
    pageUrl: "black-taj",
    style: "grid-image",
    titleLogoSrc: TajLogo,
    bannerImage: BlackTaj1,
    projectTitle: "black taj / competition",
    projectDetails: [
      {
        imageSrc: BlackTaj2,
        class: "grid2",
        imgWidth: "w-70p",
      },
      {
        description: (
          <div>
            <p>
              Always the epitome of Art, the Taj was once flanked by a necklace
              of Mughal gardens strung together by the River Yamuna. But this
              necklace has broken its string blackened and the garden jewels
              defaced. The Taj, thus, lost its context. We look at the Black Taj
              project as an opportunity to string back the garden jewels with
              the Taj.
            </p>
            <br />
            <p>
              At a broader level, we propose a 60-day spring-time Art Festival
              called the Taj Biennale hosted in the restored Mughal gardens
              along the River-front. The manifesto of the Biennale would be to
              establish a dialogue between Art and the Land. It will aim to
              bring together practitioners, researchers, artists, activists,
              entrepreneurs and organizations working in the realm of ecology
              and sustainability. This would be India’s first Biennale that uses
              the medium of Art to send a powerful message of sustainability and
              ecology to the entire world.
            </p>
            <br />
            <p>
              The Biennale would serve as a catalyst to restore the garden
              river-front of Agra, thus turning the City’s gaze back to the
              River Yamuna. The increased engagement with the City’s natural and
              historic heritage will incentivize the local community profiting
              from tourism to align with the conservation and restoration
              efforts.
            </p>
          </div>
        ),
        imgWidth: "w-60p",
      },
      {
        imageSrc: BlackTaj3,
        class: "",
        // imgWidth: "w-80p",
      },
      {
        imageSrc: BlackTaj4,
        class: "",
      },
      {
        imageSrc: BlackTaj5,
        flexAlign: "justify-content-center align-items-center",
      },
    ],
  },
  {
    project: "competitions",
    projectName: "isle",
    pageUrl: "isle-of-the-immmortals",
    style: "grid-image",
    projectTitle: "isle of immortals / competition",
    bannerImage: Youngbirds1,
    bannerImage2: Youngbirds2,
    description: (
      <div>
        <p>
          <span>
            China’s romance with the garden typology began with Qin Shi Huang’s
            legendary quest to find the Isle of the Eight Immortals. It is said
            that the first Chinese garden was built in remembrance of the quest,
            with an artificial lake built around an existing mountain and walls
            maintaining a strict perimeter. The UNESCO has identified the
            combined sites of eight Chinese gardens in Suzhou, as a World
            Heritage Site. The proposal seeks to build a continuum to this rich
            garden history of the city and hopes to re-examine the relevance of
            the garden typology in 21st century.
          </span>
        </p>
        <br />
        <p>
          <span>
            The design is primarily divided into 4 key loops each encapsulating
            a strategy:
          </span>
        </p>
        <br />
        <p>
          <strong>The Periphery:</strong>{" "}
          <span>
            Much like the wall in a traditional Chinese garden, the design hopes
            to strictly regulate the periphery of the site through a host of
            strategies that range from porous to solid.
          </span>
        </p>
        <br />
        <p>
          <strong>Spirit walk:</strong>{" "}
          <span>
            The heart of the project is a slow-moving corridor that is located
            about mid-way through the mountain, which connects the 3 temples on
            site. This is the main public interface of the project, with the
            loop designed to present a platform that allows residents on either
            side of the mountain to interact. Rammed earth is the primary
            building material that guides the architecture of this loop.
          </span>
        </p>
        <br />
        <p>
          <strong>Sky walk:</strong>{" "}
          <span>
            The existing motor-able path has been dedicated to cyclists. The
            peaks have been enclosed within a series of viewing walk-ways, that
            allow visitors to transition between views of the sunrise on the
            East and the sunset on the West.
          </span>
        </p>
        <br />
        <p>
          <strong>Orchard trail:</strong>{" "}
          <span>
            The existing scenic village route has been linked into the larger
            framework of the spirit walk and also establishes a link with the
            community to the north of the site, which was previously isolated. A
            weekly and daily farmers market and a seed bank has been planned to
            better integrate the community and its activities.
          </span>
        </p>
      </div>
    ),
    gridAlign: "justify-content-end align-items-center",
    projectDetails: [
      {
        imageSrc: Youngbirds3,
        class: "",
        imgWidth: "w-54p",
      },
      {
        imageSrc: Youngbirds4,
        class: "",
        imgWidth: "w-44p",
      },
      {
        imageSrc: Youngbirds5,
        class: "",
        imgWidth: "w-44p",
      },
      {
        imageSrc: Youngbirds6,
        class: "",
        imgWidth: "w-44p",
      },
      {
        imageSrc: Youngbirds7,
        class: "",
        imgWidth: "w-65p",
      },
      {
        imageSrc: Youngbirds8,
        class: "",
        imgWidth: "w-44p",
      },
      {
        imageSrc: Youngbirds9,
        class: "",
        imgWidth: "w-44p",
      },
    ],
  },
  {
    project: "COA",
    projectName: "coa",
    pageUrl: "center-of-excellence",
    style: "grid-image",
    projectTitle: "center of excellence / competition",
    bannerImage: Coe1,
    description: (
      <div>
        <p>
          The yearning for excellence is a quintessentially human trait. One
          cannot begin to contemplate the idea of excellence without the ideas
          of knowledge and its exchange. Unlike a school which is also a place
          of learning and exchange, a centre such as this is different in that,
          the roster of protagonists that will grace these hallowed halls and
          the concomitant activities will be in constant flux. The Centre then
          is a receptacle or a platform or a conduit that is able to encourage
          and suitably morph to the varying demands off the centre. Here in lies
          the soul of the project.
        </p>
        <br />
        <p>
          How can an architecture evolve beyond the mere programmatic demands of
          the brief and become the place that can nurture such dialogues? How
          can an architecture become a place of multiplicity and possibility?
          How can an architecture partake in this act of dissemination and
          sharing of knowledge? These are the thoughts that have guided our
          approach to the design of the centre.
        </p>
        <br />
        <p>
          Our fore fathers seemed to understand well that learning and exchange
          in the open, as in the case of the original Gurukuls, was a far more
          rewarding experience than doing so within a more structured
          environment. Our design too seeks to extend this age old wisdom. The
          design employs several strategies to dilute the sense of structure/
          enclosure/ hierarchy of space.
        </p>
      </div>
    ),
    gridAlign: "justify-content-center align-items-center",
    textLR: true,
    projectDetails: [
      {
        imageSrc: Coe2,
        class: "",
        // imgWidth: "w-80p",
        rightText: "fragmented massing",
        leftText: (
          <>
            modulating the groud plan as an
            <br /> extention to the landscap
          </>
        ),
        multiLine: true,
      },
      {
        imageSrc: Coe3,
        class: "",
        // imgWidth: "w-80p",
        rightText: "hierarchy of open spaces",
        leftText: "centre as void",
      },
      {
        imageSrc: Coe4,
        class: "",
        // imgWidth: "w-80p",
        rightText: "multiple circulation possibilities",
        leftText: "porous periphery",
      },
      {
        imageSrc: Coe5,
        class: "",
        imgWidth: "w-77p",
        leftText: "program distribution",
      },
      {
        imageSrc: Coe6,
        class: "",
        // imgWidth: "w-80p",
        gridLR: true,
        multiLine: true,
      },
      {
        imageSrc: Coe7,
        class: "",
        // imgWidth: "w-80p",
        // leftText: "view from main road",
      },
      {
        imageSrc: Coe8,
        class: "",
        // imgWidth: "w-80p",
        // leftText: "view from parking to auditorium",
      },
      {
        imageSrc: Coe9,
        class: "",
      },
    ],
  },
  {
    project: "URU_BREW",
    projectName: "uru_brew",
    pageUrl: "uru-brew",
    style: "grid-image",
    projectTitle: "uru / microbrewery / bangalore",
    gridAlign: "justify-content-center align-items-center",
    layout: "layout1",
    photoGrapherName:'Shamanth Patil J',
    projectDetails: [
      {
        imageSrc: URU1,
      },
      {
        imageSrc: URU2,
      },
      {
        imageSrc: URU3,
      },
      {
        imageSrc: URU4,      
      },
      {
        imageSrc: URU5,
      },
      {
        imageSrc: URU6,
      },
      {
        imageSrc: URU7,
      },
      {
        imageSrc: URU8,
      },
      {
        imageSrc: URU9,    
      },
      {
        imageSrc: URU10,     
      },
      {
        imageSrc: URU11,     
      },
      {
        imageSrc: URU12,
      }
    ],
  },
  {
    project: "social_bellandur",
    projectName: "social_bellandur",
    pageUrl: "social-bellandur",
    style: "grid-image",
    projectTitle: "social bellandur / restobar / bangalore",
    gridAlign: "justify-content-center align-items-center",
    layout: "layout1",
    photoGrapherName: 'Syam Sreesylam',
    creditsFooter: 'architects // rsp design consultants',
    projectDetails: [
      {
        imageSrc: SOCIALBELLA1,
      },
      {
        imageSrc: SOCIALBELLA2,
      },
      {
        imageSrc: SOCIALBELLA3,
      },
      {
        imageSrc: SOCIALBELLA4,
      },
      {
        imageSrc: SOCIALBELLA5,
      },
      {
        imageSrc: SOCIALBELLA6,
      },
      {
        imageSrc: SOCIALBELLA7,
      },
      {
        imageSrc: SOCIALBELLA8,
      },
      {
        imageSrc: SOCIALBELLA9,
      },
      {
        imageSrc: SOCIALBELLA10,
      },
      {
        imageSrc: SOCIALBELLA11,
      },
      {
        imageSrc: SOCIALBELLA12,
      },
      {
        imageSrc: SOCIALBELLA13,
      },
      {
        imageSrc: SOCIALBELLA14,
      },
      {
        imageSrc: SOCIALBELLA15,
      },
      {
        imageSrc: SOCIALBELLA16,
      },
    ],
  },
  {
    project: "record_room",
    projectName: "record_room",
    pageUrl: "record-room",
    style: "grid-image",
    projectTitle: "record room / restaurant / bangalore",
    gridAlign: "justify-content-center align-items-center",
    layout: "layout1",
    photoGrapherName: 'Shamanth Patil J',
    projectDetails: [
      {
        imageSrc: RECORDROOM1,
      },
      {
        imageSrc: RECORDROOM2,
      },
      {
        imageSrc: RECORDROOM3,
      },
      {
        imageSrc: RECORDROOM4,
      },
      {
        imageSrc: RECORDROOM5,
      },
      {
        imageSrc: RECORDROOM6,
      },
      {
        imageSrc: RECORDROOM7,
      },
      {
        imageSrc: RECORDROOM8,
      },
      {
        imageSrc: RECORDROOM9,
      },
      {
        imageSrc: RECORDROOM10,
      },
    ],
  },
  {
    project: "la_casa",
    projectName: "la_casa",
    pageUrl: "la-casa",
    style: "grid-image",
    projectTitle: "la casa / microbrewery / bangalore",
    gridAlign: "justify-content-center align-items-center",
    layout: "layout1",
    projectDetails: [
      {
        imageSrc: LACASA1,
      },
      {
        imageSrc: LACASA2,
      },
      {
        imageSrc: LACASA3,
      },
      {
        imageSrc: LACASA4,
      },
      {
        imageSrc: LACASA5,
      },
      {
        imageSrc: LACASA6,
      },
      {
        imageSrc: LACASA7,
      },
      {
        imageSrc: LACASA8,
      },
      {
        imageSrc: LACASA9,
      },
      {
        imageSrc: LACASA10,
      },
      {
        imageSrc: LACASA11,
      }
    ],
  },
  {
    project: "round",
    projectName: "round",
    pageUrl: "round",
    style: "grid-image",
    projectTitle: "round / restaurant / thrissur",
    gridAlign: "justify-content-center align-items-center",
    layout: "layout1",
    photoGrapherName: 'Shamanth Patil J',
    projectDetails: [
      {
        imageSrc: ROUND1,
      },
      {
        imageSrc: ROUND2,
      },
      {
        imageSrc: ROUND3,
      },
      {
        imageSrc: ROUND4,
      },
      {
        imageSrc: ROUND5,
      },
      {
        imageSrc: ROUND6,
      },
      {
        imageSrc: ROUND7,
      },
      {
        imageSrc: ROUND8,
      },
      {
        imageSrc: ROUND9,
      },
      {
        imageSrc: ROUND10,
      }
    ],
  },
   {
    project: "kaavu",
    projectName: "kaavu",
    pageUrl: "kaavu",
    style: "grid-image",
    projectTitle: "kaavu / restobar / bangalore",
    gridAlign: "justify-content-center align-items-center",
    layout: "layout1",
    photoGrapherName:'Gregory kuzmik',
    projectDetails: [
      {
        imageSrc: KAAVU1,
      },
      {
        imageSrc: KAAVU2,
      },
      {
        imageSrc: KAAVU3,
      },
      {
        imageSrc: KAAVU4,
      },
      {
        imageSrc: KAAVU5,
      },
      {
        imageSrc: KAAVU6,
      },
      {
        imageSrc: KAAVU7,
      },
      {
        imageSrc: KAAVU8,
      },
      {
        imageSrc: KAAVU9,
      },
      {
        imageSrc: KAAVU10,
      },
      {
        imageSrc: KAAVU11,
      },
      {
        imageSrc: KAAVU12,
      },
      {
        imageSrc: KAAVU13,
      },
      {
        imageSrc: KAAVU14,
      },
       {
        imageSrc: KAAVU15,
      }
    ],
  },
  {
    project: "gcbc",
    projectName: "gcbc",
    pageUrl: "gcbc",
    style: "grid-image",
    projectTitle: "gcbc / microbrewery / bangalore",
    gridAlign: "justify-content-center align-items-center",
    layout: "layout1",
    photoGrapherName:'Shamanth Patil J',
    creditsFooter: 'architects // parallax',

    projectDetails: [
      {
        imageSrc: GCBC1,
      },
      {
        imageSrc: GCBC2,
      },
      {
        imageSrc: GCBC3,
      },
      {
        imageSrc: GCBC4,
      },
      {
        imageSrc: GCBC5,
      },
      {
        imageSrc: GCBC6,
      },
      {
        imageSrc: GCBC7
      },
      {
        imageSrc: GCBC8
      },
      {
        imageSrc: GCBC9,
      },
      {
        imageSrc: GCBC10,
      },
      {
        imageSrc: GCBC11,
      }
    ],
  },
   {
    project: "earthsong",
    projectName: "earthsong",
    pageUrl: "earth-song",
    style: "grid-image",
    projectTitle: "earth song / summer house / ooty",
    gridAlign: "justify-content-center align-items-center",
    layout: "layout1",
    photoGrapherName:'Gregory kuzmik',
    projectDetails: [
      {
        imageSrc: ESONG1,
      },
      {
        imageSrc: ESONG2,
      },
      {
        imageSrc: ESONG3,
      },
      {
        imageSrc: ESONG4,
      },
      {
        imageSrc: ESONG5,
      },
      {
        imageSrc: ESONG6,
      },
      {
        imageSrc: ESONG7,
      },
      {
        imageSrc: ESONG8,
      },
      {
        imageSrc: ESONG9,
      },
      {
        imageSrc: ESONG10,
      },
      {
        imageSrc: ESONG11,
      },
      {
        imageSrc: ESONG12,
      },
      {
        imageSrc: ESONG13,
      },
       {
        imageSrc: ESONG14,
      },
      {
        imageSrc: ESONG15,
      },
      {
        imageSrc: ESONG16,
      },
      {
        imageSrc: ESONG17,
      },
      {
        imageSrc: ESONG18,
      },
      {
        imageSrc: ESONG19,
      },
      {
        imageSrc: ESONG20,
      },
      {
        imageSrc: ESONG21,
      }
    ],
  },
  {
    project: "manchanda",
    projectName: "manchanda",
    pageUrl: "manchanda",
    style: "grid-image",
    projectTitle: "manchanda / office / bangalore",
    gridAlign: "justify-content-center align-items-center",
    layout: "layout1",
    photoGrapherName: 'Syam Sreesylam',
    projectDetails: [
      {
        imageSrc: MANCHANDA1
      },
      {
        imageSrc: MANCHANDA2
      },
      {
        imageSrc: MANCHANDA3
      },
      {
        imageSrc: MANCHANDA4
      },
      {
        imageSrc: MANCHANDA5
      },
      {
        imageSrc: MANCHANDA6
      },
      {
        imageSrc: MANCHANDA7
      },
      {
        imageSrc: MANCHANDA8
      },
      {
        imageSrc: MANCHANDA9
      },
      {
        imageSrc: MANCHANDA10
      },
      {
        imageSrc: MANCHANDA11
      },
      {
        imageSrc: MANCHANDA12
      },
      {
        imageSrc: MANCHANDA13
      },
       {
        imageSrc: MANCHANDA14
      },
      {
        imageSrc: MANCHANDA15,
      }
    ],
  },
  {
    project: "p-515",
    projectName: "p-515",
    pageUrl: "p-515",
    style: "grid-image",
    projectTitle: "515 / office / bangalore",
    gridAlign: "justify-content-center align-items-center",
    layout: "layout1",
    photoGrapherName: 'Gregory kuzmik',
    projectDetails: [
      {
        imageSrc: P5151,
      },
      {
        imageSrc: P5152,
      },
      {
        imageSrc: P5153,
      },
      {
        imageSrc: P5154,
      },
      {
        imageSrc: P5155,
      },
      {
        imageSrc: P5156,
      },
      {
        imageSrc: P5157,
      },
      {
        imageSrc: P5158,
      },
      {
        imageSrc: P5159,
      },
      {
        imageSrc: P51510,
      }
    ],
  },
  {
    project: "maratt",
    projectName: "maratt",
    pageUrl: "maratt",
    style: "grid-image",
    projectTitle: "maratt / office / bangalore",
    gridAlign: "justify-content-center align-items-center",
    layout: "layout1",
    photoGrapherName: 'Gregory kuzmik',
    projectDetails: [
      {
        imageSrc: MARATT1,
      },
      {
        imageSrc: MARATT2,
      },
      {
        imageSrc: MARATT3,
      },
      {
        imageSrc: MARATT4,
      },
      {
        imageSrc: MARATT5,
      },
      {
        imageSrc: MARATT6,
      },
      {
        imageSrc: MARATT7,
      },
      {
        imageSrc: MARATT8,
      },
      {
        imageSrc: MARATT9,
      },
      {
        imageSrc: MARATT10,
      },
      {
        imageSrc: MARATT11,
      },
      {
        imageSrc: MARATT12,
      },
      {
        imageSrc: MARATT13,
      },
       {
        imageSrc: MARATT14,
      }
    ],
  },
   {
    project: "transit",
    projectName: "transit",
    pageUrl: "363-transit",
    style: "grid-image",
    projectTitle: "363 transit / office / bangalore",
    gridAlign: "justify-content-center align-items-center",
    layout: "layout1",
    photoGrapherName: 'Gregory kuzmik',
    projectDetails: [
      {
        imageSrc: TRANSIT1,
      },
      {
        imageSrc: TRANSIT2,
      },
      {
        imageSrc: TRANSIT3,
      },
      {
        imageSrc: TRANSIT4,
      },
      {
        imageSrc: TRANSIT5,
      },
      {
        imageSrc: TRANSIT6,
      },
      {
        imageSrc: TRANSIT7,
      },
      {
        imageSrc: TRANSIT8,
      },
      {
        imageSrc: TRANSIT9,
      },
      {
        imageSrc: TRANSIT10,
      },
      {
        imageSrc: TRANSIT11,
      },
      {
        imageSrc: TRANSIT12,
      }
    ],
  },
  {
    project: "micelio",
    projectName: "micelio",
    pageUrl: "micelio",
    style: "grid-image",
    projectTitle: "micelio / office / bangalore",
    gridAlign: "justify-content-center align-items-center",
    layout: "layout1",
    photoGrapherName: 'Gregory kuzmik',
    projectDetails: [
      {
        imageSrc: MICELIO1,
      },
      {
        imageSrc: MICELIO2,
      },
      {
        imageSrc: MICELIO3,
      },
      {
        imageSrc: MICELIO4,
      },
      {
        imageSrc: MICELIO5,
      },
      {
        imageSrc: MICELIO6,
      },
      {
        imageSrc: MICELIO7,
      },
      {
        imageSrc: MICELIO11,
      },
      {
        imageSrc: MICELIO12,
      },
      {
        imageSrc: MICELIO13,
      },
       {
        imageSrc: MICELIO14,
      },
      {
        imageSrc: MICELIO15,
      },
      {
        imageSrc: MICELIO16,
      }
    ],
  },
];

export default projectPageData;
